/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class BoardRanges extends Logic
{
  getColonies ()
  {
    return this.object.getColonies().values();
  }


  getColoniesByAttachDate ()
  {
    return this.getColonies().sort((lhs, rhs) => lhs.cass.attachDate - rhs.cass.attachDate);
  }


  getUsersByAttachDate ()
  {
    const users = new Set(this.getColoniesByAttachDate().map(colony => colony.cass.user));

    return [ ...users ].map(user => this.object.getUser(user));
  }


  getColoniesByAccount (account)
  {
    return account.getCurrentColonyViews().values().map(view => this.object.getColony(view.cass.colony)).filter(colony => colony !== null);
  }


  getSectors ()
  {
    return this.object.getColonies().flatMap(colony => colony.getSectors().values());
  }


  getZones ()
  {
    return this.object.getZones().values();
  }


  getAnchors ()
  {
    return this.object.getColonies().flatMap(colony => colony.getOutboundAnchors().values());
  }


  getInfluences ()
  {
    return this.object.getZones().values().flatMap(zone => zone.getInfluences().values());
  }


  getUsers ()
  {
    return this.object.getUsers().values();
  }


  getAccountViews ()
  {
    return this.object.getAccountViews().values();
  }


};
